import Button from "../button";
import { DisplayFullPageErrorArgs } from "./types";

export default function DisplayFullPageError(props: DisplayFullPageErrorArgs) {
  return (
    <div className="fullPageError">
      <p className="fullPageError-message" dangerouslySetInnerHTML={{ __html: props.message }} />
      <Button.Link className="mt-10" label={props.closeButtonLabel} onClick={props.closeHandler} />
    </div>
  );
}
